import { useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = ({ onOpenPrivacy, onOpenTerms }) => {
  const [showEmail, setShowEmail] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  
  // Obfuscated contact info (protection against scrapers)
  const emailUser = 'hello';
  const emailDomain = 'landinglab';
  const emailTld = 'hu';
  const phoneParts = ['+36', '70', '329', '5854'];
  
  const getEmail = () => `${emailUser}@${emailDomain}.${emailTld}`;
  const getPhone = () => phoneParts.join(' ');
  const getPhoneLink = () => phoneParts.join('').replace(/\s/g, '');

  return (
    <footer id="kapcsolat" data-testid="footer" className="bg-ink-2 py-16 border-t border-white/5" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h3 className="font-sora font-bold text-2xl text-on-dark">Kapcsolat</h3>
            <p className="mt-4 text-on-dark/60">
              Általában 1 munkanapon belül válaszolunk.
            </p>
            <address className="mt-6 space-y-3 not-italic">
              {/* Email with scraper protection */}
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-primary flex-shrink-0" aria-hidden="true" />
                {showEmail ? (
                  <a 
                    href={`mailto:${getEmail()}`} 
                    className="text-on-dark/80 hover:text-on-dark transition-colors"
                    aria-label="Email cím"
                  >
                    {getEmail()}
                  </a>
                ) : (
                  <div className="flex items-center gap-2">
                    <span className="text-on-dark/80">hello@landi...</span>
                    <button
                      onClick={() => setShowEmail(true)}
                      className="px-2 py-0.5 text-xs rounded-full bg-primary text-white hover:bg-primary/90 transition-colors"
                    >
                      Mutasd
                    </button>
                  </div>
                )}
              </div>
              
              {/* Phone with scraper protection */}
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-primary flex-shrink-0" aria-hidden="true" />
                {showPhone ? (
                  <a 
                    href={`tel:${getPhoneLink()}`} 
                    className="text-on-dark/80 hover:text-on-dark transition-colors"
                    aria-label="Telefonszám"
                  >
                    {getPhone()}
                  </a>
                ) : (
                  <div className="flex items-center gap-2">
                    <span className="text-on-dark/80">+36 70 3...</span>
                    <button
                      onClick={() => setShowPhone(true)}
                      className="px-2 py-0.5 text-xs rounded-full bg-primary text-white hover:bg-primary/90 transition-colors"
                    >
                      Mutasd
                    </button>
                  </div>
                )}
              </div>
              
              <div className="flex items-center gap-3 text-on-dark/60">
                <MapPin size={18} className="text-primary" aria-hidden="true" />
                Budapest, Magyarország
              </div>
            </address>
          </div>
          
          <div className="flex flex-col justify-between">
            <div>
              <img 
                src="/logo.svg" 
                alt="LandingLab - ügyfélszerző weboldalak készítése" 
                className="h-7 w-auto"
                width="112"
                height="20"
              />
              <p className="mt-3 text-on-dark/60 text-sm">
                Professzionális weboldal készítés és honlap készítés szolgáltatóknak. Ügyfélszerző oldalak fix áron.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mt-8">
              <p className="text-on-dark/70 text-sm">
                © {new Date().getFullYear()} LandingLab. Minden jog fenntartva.
              </p>
              <div className="flex gap-4">
                <button
                  onClick={onOpenPrivacy}
                  className="text-on-dark/70 hover:text-on-dark text-sm transition-colors"
                  data-testid="footer-privacy"
                >
                  Adatvédelem
                </button>
                <button
                  onClick={onOpenTerms}
                  className="text-on-dark/70 hover:text-on-dark text-sm transition-colors"
                  data-testid="footer-terms"
                >
                  ÁSZF
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
